<template>
  <div class="social-comment list-complete-item">
    <div class="comment-header" v-if="comment.owner != null">
      <i class="social-comment-icon"></i>
      <img :src="$imageus + (comment.owner.image == null ? host + '/static/img/500x500-user.png' : comment.owner.image) + '?width=200&height=200&mode=cover'" alt="" />
      <div class="comment-user-title">
        <span class="comment-user-title-text">
          {{ comment.owner.fullName }}
        </span>
        <span class="time">{{ $moment(comment.createDate).fromNow() }}</span>
      </div>
      <el-dropdown trigger="click" class="post-actions">
        <span class="el-dropdown-link">
          <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="deleteComment" icon="fas fa-trash">{{ $t("components.socialhub.postCard.deleteComment") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="comment-body">
      <div class="comment-text" v-html="parseUrl(comment.commentText, comment)"></div>
      <div class="comment-buttons">
        <!-- <span>{{moment(comment.createDate).fromNow()}}</span> -->
        <span @click="openSubComment">{{ comment.subCommentCount }} {{ $t("components.socialhub.postCard.comment") }}</span>
        <span
          class="comment-reply"
          :style="{ color: newComment ? '#FF6565' : '#292F3B' }"
          @click="
            newComment = !newComment;
            commentForm.commentText = null;
          "
          >{{ newComment ? $t("components.socialhub.postCard.cancel") : $t("components.socialhub.postCard.reply") }}</span
        >
        <div class="like-area" @click="toggleLikeComment">
          <i class="el-icon-loading" v-if="loading == 'commentLike'"></i>
          <i class="fa fa-heart" v-else :class="{ active: comment.isLiked }"></i>
          <span v-if="comment.likeCount > 0">{{ comment.likeCount }}</span>
        </div>
      </div>
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="send-comment" v-if="newComment" :key="'new-comment-area-' + comment.id + '-key-' + newComment" @keyup.enter.exact="postComment">
          <div v-if="isCommentMentionVisible" v-swiper:mySwiper="swiperOption" class="mention-panel">
            <div class="swiper-wrapper">
              <div v-for="(user, index) in users" :key="index" @click.stop="tagUser(user, commentForm)" class="mention-item swiper-slide">
                <div :style="user.image == null ? host + '/static/img/500x500-user.png' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
                <p v-if="user.type == 2">{{ user.title }}</p>
                <p else>{{ user.fullName }}</p>
              </div>
            </div>
          </div>
          <el-input v-model="commentForm.commentText" resize="auto" class="comment-input" @input="commentMention(commentForm)">
            <template slot="suffix">
              <i class="el-input__icon fas " :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment"></i>
            </template>
          </el-input>
        </div>
      </transition>
      <div class="comment-sub-comments" v-if="subCommentOpen">
        <transition-group name="list-complete" tag="div">
          <SubComment v-for="subComment in comment.subComments" :key="subComment.id + '-sub-comment'" @deleteMe="deleteSubComment" :subComment="subComment" />
        </transition-group>
        <div class="load-comment-btn" v-if="loadCommentBtn">
          <el-button type="primary" round size="mini" :loading="loading == 'loadComments'" @click="loadComment">{{ $t("components.socialhub.postCard.loadMore") }}</el-button>
        </div>
        <div class="load-comment-btn" v-else>
          <el-button size="mini" type="success" round @click="subCommentOpen = false">{{ $t("components.socialhub.postCard.hideReply") }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubComment from "./SubComment.vue";
export default {
  props: ["comment"],
  components: {
    SubComment
  },
  data() {
    return {
      host: location.host == "localhost:8081" ? "https://app.holacon.com" : "https://" + location.host,
      subCommentOpen: false,
      newComment: false,
      users: [],
      firstOpen: false,
      isCommentMentionVisible: false,
      commentForm: {
        id: null,
        postId: this.comment.postId,
        commentText: null,
        parentId: this.comment.id,
        mentions: []
      },
      swiperOption: {
        slidesPerView: "auto",
        autoWidth: true,
        spaceBetween: 20
      },
      searchTerm: null,
      loading: false,
      timeout: null,
      loadCommentBtn: true
    };
  },
  methods: {
    async deleteComment() {
      var res = await this.$store.dispatch("socialHubDeleteComment", this.comment.id);
      if (!res.data.alert.hasError) {
        this.$emit("deleteMe", this.comment.id);
      }
    },
    deleteSubComment(commentId) {
      var fIndex = this.comment.subComments.findIndex(x => x.id == commentId);
      if (fIndex != -1) {
        this.comment.subComments.splice(fIndex, 1);
      }
    },
    async loadComment() {
      this.loading = "loadComments";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubListComments", {
          skip: this.comment.subComments.length,
          take: 5,
          parentId: this.comment.id,
          postId: this.comment.postId
        });
        var comments = res.data.data.items;
        if (comments.length > 0) {
          this.comment.subComments.push(...comments.reverse());
        }
        if (res.data.data.items.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.loading = false;
      }, 500);
    },
    async openSubComment() {
      if (!this.firstOpen) {
        var res = await this.$store.dispatch("socialHubListComments", {
          skip: this.comment.subComments.length,
          take: 5,
          parentId: this.comment.id,
          postId: this.comment.postId
        });
        var comments = res.data.data.items;
        if (comments.length > 0) {
          this.comment.subComments.push(...comments.reverse());
        }
        if (res.data.data.items.length == 5) {
          this.skip += 5;
          this.loadCommentBtn = true;
        } else {
          this.loadCommentBtn = false;
        }
        this.firstOpen = true;
      }

      this.subCommentOpen = !this.subCommentOpen;
    },
    async toggleLikeComment() {
      this.loading = "commentLike";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.comment.id,
          postId: this.comment.postId,
          isLiked: !this.comment.isLiked
        };
        var res = await this.$store.dispatch("toggleLikeComment", payload);
        if (res.status == 200) {
          if (!res.data.alert.hasError) {
            this.comment.isLiked = !this.comment.isLiked;
          }
        } else {
          this.loading = false;
          this.$message.error("Bir hata oluştu");
        }

        this.loading = false;
      }, 500);
    },
    // commentMention(post) {
    //   if (this.commentForm.commentText != "" && this.commentForm.commentText != null) {
    //     this.commentForm.commentText.split(" ").forEach(item => {
    //       if (item.startsWith("@")) {
    //         this.users = [];
    //         this.isCommentMentionVisible = true;
    //         this.searchTerm = item.replace("@", "");
    //         setTimeout(() => {
    //           axios
    //             .post("socialhub/searchmention", {
    //               searchTerm: this.searchTerm
    //             })
    //             .then(res => {
    //               this.users = res.data.data.items;
    //             });
    //         }, 1000);
    //       } else {
    //         this.isCommentMentionVisible = false;
    //         this.searchTerm = "";
    //       }
    //     });
    //   }
    // },
    commentMention(post) {
      console.log(post, "comment");
      if (this.commentForm.commentText != "" && this.commentForm.commentText != null) {
        this.commentForm.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            this.timeout = setTimeout(async () => {
              var res = await this.$store.dispatch("socialHubMentionSearch", this.searchTerm);
              this.users = res.data.data.items;
            }, 500);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    postComment() {
      this.loading = "postCommentLoading";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.commentForm.commentText;
        if (commentTitle != null && commentTitle != "") {
          this.commentForm.mentions.forEach(user => {
            commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
          });
          var res = await this.$store.dispatch("socialHubAddUpdateComment", {
            id: null,
            parentId: this.comment.id,
            postId: this.comment.postId,
            commentText: commentTitle != "" ? commentTitle : this.commentForm.commentText,
            mentions: this.commentForm.mentions
          });
          if (res.data.hasError == true) {
            this.$message.error(res.data.message);
          } else {
            this.commentForm.commentText = null;
            this.users = [];
          }
          this.commentForm.mentions = [];
          this.newComment = false;
        } else {
          this.$message.error(this.$t("components.socialhub.postCard.pleaseWrite"));
        }
        this.loading = false;
      }, 500);
    },
    tagUser(user, post) {
      this.isCommentMentionVisible = false;
      this.commentForm.commentText = this.commentForm.commentText.replaceAll("@" + this.searchTerm, user.fullName);
      this.commentForm.mentions.push(user);
      this.users = [];
      this.searchTerm = "";
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    }
  }
};
</script>

<style scoped lang="less">
.social-comment {
  padding: 10px 0px 10px 0;
  margin-right: 0px;
  border-top: 0.5px solid rgba(200, 205, 211, 0.4);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .comment-header {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #e8ebef;
      object-fit: cover;
    }
    .comment-user-title  {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      display: flex;
      flex-direction: column;
      .time {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.2px;
        color: #8c929c;
      }
    }
    .post-actions {
      color: #8c929c;
      font-size: 12px;
      text-align: end;
      justify-self: flex-end;
      cursor: pointer;
      margin-left: auto;
      margin-right: 1rem;
      span {
        i {
          font-size: 16px;
        }
      }
    }
  }
  .comment-body {
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #292f3b;
    .comment-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #505763;
    }
    .comment-buttons {
      display: flex;
      align-items: center;
      gap: 4px;
      & > span {
        cursor: pointer;
        user-select: none;
      }
      .comment-reply {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        text-decoration-line: underline;
        color: #292f3b;
        margin-left: 4px;
        cursor: pointer;
      }
      .like-area {
        margin-left: auto;
        display: flex;
        align-items: center;
        margin-right: 8px;
        cursor: pointer;
        flex-direction: column;
        & > i {
          font-size: 14px;
          &.active {
            transition: all 0.2s;
            color: #ff6565;
          }
        }
        span {
          font-size: 12px;
        }
      }
    }
    .comment-sub-comments {
      .load-comment-btn {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .send-comment {
      position: relative;
      .mention-panel {
        // swiper container
        position: absolute;
        top: calc(~"-100% - 1.5rem");
        left: 0;
        display: flex;
        gap: 10px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(41, 47, 59, 0.24);
        border-radius: 12px;
        padding: 10px;
        height: 60px;
        width: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
        .mention-item {
          flex-shrink: 0;
          cursor: pointer;
          display: flex;
          gap: 8px;
          width: max-content;
          align-items: center;
          .user-image {
            border: 2px solid #e8ebef;
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background-size: cover;
            flex-shrink: 0;
          }
          p {
            margin-bottom: 0;
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
            color: #292f3b;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/NewComment.vue